import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { baseStyles } from '@/styles';
import { iconExclamationTriangle } from '../icons';

@customElement('fg-message')
export class FgMessage extends LitElement {
  @property({ type: String })
  message? = '';

  @property({ type: String })
  type = 'error';

  @property({ type: String })
  messageId = '';

  render() {
    if (!this.message) {
      return nothing;
    }

    return html`
      <div class="message ${this.type}" id="${this.messageId}">
        <span class="icon">${iconExclamationTriangle}</span>
        <span class="text">${this.message}</span>
      </div>
    `;
  }

  static styles = [
    baseStyles,
    css`
      .message {
        font-size: 1rem;
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .message.error {
        background-color: var(
          --fg-error-background,
          var(--fg-fallback-error-background)
        );
        color: var(--fg-error-content, var(--fg-fallback-error-content));
      }
      .message.error .icon svg {
        fill: var(--fg-error-content, var(--fg-fallback-error-content));
      }

      .message.info {
        background-color: var(
          --fg-infobox-background,
          var(--fg-fallback-infobox-background)
        );
        color: var(--fg-infobox-content, var(--fg-fallback-infobox-content));
      }
      .message.info .icon svg {
        fill: var(--fg-infobox-content, var(--fg-fallback-infobox-content));
      }

      .icon {
        display: flex;
        align-items: center;
        height: 100%;
      }

      .icon svg {
        width: 16px;
        height: 16px;
      }

      :host([part='retail']) .message {
        margin-top: 10px;
        padding: 14px 18px;
        font-weight: 700;
        border-radius: var(--fg-borderradius, var(--fg-fallback-borderradius));
      }

      :host([part='wholesale']) .message {
        margin-top: 0;
        font-weight: 500;
        padding: 0.5rem 1rem;
        border-radius: var(
          --fg-borderradius--xs,
          var(--fg-fallback-borderradius--xs)
        );
      }

      :host([part='wholesale']) .message.info {
        border: 1px solid
          var(--fg-infobox-content, var(--fg-fallback-infobox-content));
      }

      :host([part='wholesale']) .message.error {
        border: 1px solid
          var(--fg-error-content, var(--fg-fallback-error-content));
      }
    `,
  ];
}
